import { PlaySquareOutlined } from "@ant-design/icons";
import { ResourceProps } from "@refinedev/core";

// 11615 «ФНЛ ТВ»: группа в меню и её подразделы. Ключи прав — пути list-роутов (см. access/sections.ts).

export const tvResource: ResourceProps = {
  name: "tv",
  meta: { icon: <PlaySquareOutlined />, label: "ФНЛ ТВ" },
};

const child = (
  name: string,
  path: string,
  label: string,
  withShow = true
): ResourceProps => ({
  name,
  list: `/tv/${path}`,
  ...(withShow
    ? { show: `/tv/${path}/:id`, create: `/tv/${path}/create` }
    : {}),
  // meta.route: Refine собирает из него путь для проверки прав (/tv/videos), иначе взял бы имя ресурса.
  meta: { parent: "tv", label, route: path },
});

export const tvResources: ResourceProps[] = [
  tvResource,
  child("tv-videos", "videos", "Видео"),
  child("tv-shows", "shows", "Шоу и спецпроекты"),
  child("tv-collections", "collections", "Подборки"),
  child("tv-showcase", "showcase", "Витрина"),
  child("tv-leagues", "leagues", "Шапки лиг", false),
  child("tv-matches", "matches", "Матчи", false),
  child("tv-settings", "settings", "Настройки", false),
];
